import {request} from "../../../api-client";
import HomeElementGridContainer from "../HomeElements/HomeElementGridContainer";
import GridItem from "../HomeElements/GridItem";
import React, {Component} from "react";
import TrackTable from "../../../components/Letflow/TrackTable";
import EventManager, {events} from "../../../utils/EventManager"
import HomeElementCarousel from "../HomeElements/HomeElementCarousel";

class Browse extends Component {
  constructor(props) {
    super(props);
    this.state = {
      homeElement: null,
      favorites: [],
      requesting: false
    }
  }

  componentDidMount = () => {
    document.getElementsByTagName('html')[0].scrollTop = 0
    this.requestBrowseElement(this.props.elementId).then(() => this.requestMyList())

    EventManager.getInstance().subscribe(events.ADD_TO_FAVORITE_BUTTON_PRESS, this.addToMyList)
    EventManager.getInstance().subscribe(events.REMOVE_FROM_FAVORITE_BUTTON_PRESS, this.removeFromMyList)
  }

  requestMyList = () => new Promise(resolve => {
    request.contentCreatorFavorite.getAll().then(contentCreatorsFavorites => this.setState({contentCreatorsFavorites}))
    request.contentCreationFavorite.getAll().then(contentCreationsFavorites => this.setState({contentCreationsFavorites}))
    resolve()
  })

  addToMyList = ({id, type}) => {
    let {contentCreatorsFavorites, contentCreationsFavorites} = this.state
    switch (type) {
      case 'content_creator':
        contentCreatorsFavorites.push(id)
        request.contentCreatorFavorite.add(id)
        break
      case 'video_content_creation':
        contentCreationsFavorites.push(id)
        request.contentCreationFavorite.add(id)
        break
    }
  }


  componentWillUnmount = () => {
    EventManager.getInstance().unsubscribe(events.ADD_TO_FAVORITE_BUTTON_PRESS, this.addToMyList)
    EventManager.getInstance().unsubscribe(events.REMOVE_FROM_FAVORITE_BUTTON_PRESS, this.removeFromMyList)
  }

  removeFromMyList = ({id, type = 'content_creator'}) => {
    let {contentCreatorsFavorites, contentCreationsFavorites} = this.state
    switch (type) {
      case 'content_creator':
        if (contentCreatorsFavorites.indexOf(id) > -1) {
          contentCreatorsFavorites.splice(contentCreatorsFavorites.indexOf(id), 1)
        }
        request.contentCreatorFavorite.remove(id)
        break
      case 'video_content_creation':
        if (contentCreationsFavorites.indexOf(id) > -1) {
          contentCreationsFavorites.splice(contentCreationsFavorites.indexOf(id), 1)
        }
        request.contentCreationFavorite.remove(id)
        break
    }
    this.setState({contentCreatorsFavorites, contentCreationsFavorites})
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if (!!this.state.homeElement && nextProps.elementId != this.state.homeElement.id && !this.state.requesting) {
      this.requestBrowseElement(nextProps.elementId)
    }
  }

  requestBrowseElement = id =>
    new Promise(resolve => {
      this.setState({requesting: true}, () =>
        request.home.getElementById(id)
          .then(response => this.setState({homeElement: response, requesting: false}))
      )

      document.getElementsByTagName('html')[0].scrollTop = 0
      resolve()
    })

  renderSearchResultsTableTags = () => {
    const Container = ({children}) => <div ref={r => this.resultsTableTags = r} style={{
      float: 'left',
      position: 'relative',
      width: '100%',
      backgroundColor: "white",
    }}>{children}</div>
    let content;
    switch (this.state.homeElement.view_type) {
      case "grid":
        content =
          <div className="smart-search-result-container">
            <HomeElementGridContainer
              {...this.props}
              maxPerRow={this.state.homeElement.columns}
              homeElement={this.makeHomeElementProp(this.state.homeElement.items.data)}
              trackType={this.makeTrackTypeProp()}
              dataType={this.makeDataTypeProp()}
              showSectionTitle={false}
              shape={this.state.homeElement.shape}
              fixedTitle={this.state.homeElement.fixed_title}
              withBackground={this.state.homeElement.with_background}
              sizes={{
                xs: 12,
                sm: 4,
                md: 3,
                lg: 3,
                xl: 3,
              }}
              showMore={!!this.state.homeElement.items.data.length}
              rowsToShow={this.state.homeElement.rows_to_show || 3}
              itemComponent={GridItem}
            />
          </div>
        break;
      case "carousel":
        content = <HomeElementCarousel
          {...this.props}
          homeElement={this.makeHomeElementProp(this.state.homeElement.items.data)}
          trackType={this.makeTrackTypeProp()}
          dataType={this.makeDataTypeProp()}
          onlyImage={this.state.homeElement.only_image}
          numbered={this.state.homeElement.numbered}
          shape={this.state.homeElement.shape}
          columns={this.state.homeElement.columns}
        />
        break;
      default:
        content = <div className="smart-search-result-container">
          <HomeElementGridContainer
            {...this.props}
            maxPerRow={6}
            homeElement={this.makeHomeElementProp(this.state.homeElement.items.data)}
            trackType={this.makeTrackTypeProp()}
            dataType={this.makeDataTypeProp()}
            showSectionTitle={false}
            shape={this.state.homeElement.shape}
            fixedTitle={this.state.homeElement.fixed_title}
            withBackground={this.state.homeElement.with_background}
            sizes={{
              xs: 12,
              sm: 4,
              md: 3,
              lg: 3,
              xl: 3,
            }}
            showMore={!!this.state.homeElement.items.data.length}
            rowsToShow={this.state.homeElement.rows_to_show || 3}
            itemComponent={GridItem}
          />
        </div>
    }

    return <Container>{content}</Container>
  }

  makeDataTypeProp = () => {
    if (this.state.homeElement.data_source === "channel_playlist") {
      return 'content_creator'
    } else {
      return this.state.homeElement.data_source
    }
  }

  makeTrackTypeProp = () => {
    switch (this.state.homeElement.data_source) {
      case 'user_library':
        return (itemType) => itemType
      default:
        return () => 'music'
    }
  }

  isFavorite = (item) => {
    switch (this.state.homeElement.data_source) {
      case 'channel_playlist':
        return this.state.contentCreatorsFavorites ? this.state.contentCreatorsFavorites.includes(item.id) : false
      case 'content_creator':
        return this.state.contentCreatorsFavorites ? this.state.contentCreatorsFavorites.includes(item.id) : false
      default:
        return this.state.favorites ? this.state.favorites.includes(item.id) : false
    }
  }

  makeHomeElementProp = (contentCreations) => {
    return {
      ...contentCreations,
      items: {
        data: contentCreations.map(item => ({
          ...item,
          title: item.title,
          shortDescription: item.description,
          kind: this.state.homeElement.data_source === "channel_playlist" ? "content_creator" : this.state.homeElement.data_source,
          favorite: this.isFavorite(item)
        }))
      }
    }
  }

  renderTrackTable = () => {
    const Container = ({children}) => <div ref={r => this.resultsTableTags = r} style={{
      float: 'left',
      position: 'relative',
      width: '100%',
      backgroundColor: "white",
      marginTop: "30px"
    }}>{children}</div>

    let content =
      <div className="smart-search-result-container" style={{padding: "0 50px"}}>
        <TrackTable {...this.props} channel={this.state.channel} type={'music'}
                    tracks={this.state.homeElement.items.data} fromHome={true}/>
      </div>

    return <Container>{content}</Container>
  }

  render = () => {
    return (
      <div id="innerinner" style={{marginBottom: '10px'}}>
        {!!this.state.homeElement &&
        <>
          <h2 style={{textAlign: "center", fontSize: 30, marginTop: 40}}>{this.state.homeElement.title}</h2>
          {this.renderSearchResultsTableTags()}
        </>
        }
      </div>
    )
  }
}

export default Browse;